import { User } from "@/types/models/User.interface";
import { UserRole } from "@/types/models/User/v3/UserRoles.interface";

const ROLE_LABELS: Array<[UserRole, string]> = [
  ["district_admin", "District administrator"],
  ["school_admin", "School administrator"],
  ["principal", "School administrator"],
  ["teacher", "Teacher"],
  ["parent", "Caregiver"],
  ["student", "Student"],
];

export const getRoleLabel = (user: Pick<User, "is_staff" | "roles">) => {
  if (user.is_staff) return "Newsela staff";

  return ROLE_LABELS.find(([role]) => user.roles?.includes(role))?.[1];
};
